import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { fbqTrack } from "@/lib/track";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ruta360_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("ruta360_cart", JSON.stringify(items));
  }, [items]);

  const add = (product) => {
    setItems((prev) => {
      const found = prev.find((i) => i.id === product.id);
      if (found) return prev.map((i) => (i.id === product.id ? { ...i, qty: i.qty + 1 } : i));
      return [...prev, { id: product.id, name: product.name, price_mxn: product.price_mxn, image: product.image, qty: 1 }];
    });
    fbqTrack("AddToCart", { content_name: product.name, content_ids: [product.id], value: product.price_mxn, currency: "MXN" });
    toast.success("Agregado al carrito");
  };

  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const setQty = (id, qty) =>
    setItems((prev) =>
      qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty } : i))
    );
  const clear = () => setItems([]);

  const { count, total } = useMemo(
    () => ({
      count: items.reduce((s, i) => s + i.qty, 0),
      total: items.reduce((s, i) => s + i.qty * i.price_mxn, 0),
    }),
    [items]
  );

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, open, setOpen, count, total }}>
      {children}
    </CartContext.Provider>
  );
};
